import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Product, InventoryLocation } from '../shared/models';
import { InputFilterSheetComponent } from '../shared/ui';
import { AppPageComponent } from '../../shared/ui';
import {  UserService, StoreHelper, Store, AppStateService } from '../../shared/services';
import { TopLevelComponent, HeaderAction } from '../../shared/models';
import { InventoryDetailService } from './inventory-detail.service';
import { MenuItem } from 'ng2-material-components/ng2-material-components';

@Component({
    selector: 'inventory-detail',
    styles: [ require('./inventory-detail.component.scss') ],
    template: require('./inventory-detail.component.pug')
})
export class InventoryDetailComponent extends TopLevelComponent implements OnInit {
    @ViewChild(AppPageComponent) appPage;
    @ViewChild(InputFilterSheetComponent) inputFilterSheetComponent;

    fg = new FormGroup({});
    showReportDetails: boolean = false;
    product: Product =  <Product>{};
    locationSelectedToReport: InventoryLocation;
    locations: Array<InventoryLocation>;
    actionItems: Array<MenuItem> = [<MenuItem>{icon: 'edit'}, <MenuItem>{icon: 'card-alert'}, <MenuItem>{icon: 'swap'}];
    editActionItems: Array<MenuItem> = [<MenuItem>{icon: 'check'}, <MenuItem>{icon: 'undo'}];

    private _totalLocations: number = 0;
    private _searchAction = { id: 'search', icon: 'search' };

    constructor(
                private _appStateService: AppStateService,
                public _inventoryDetailService: InventoryDetailService,
                public _route: ActivatedRoute,
                public _router: Router,
                _store: Store,
                _storeHelper: StoreHelper,
                _userSvc: UserService
               ) {
          super(_store, _storeHelper, _userSvc);
          this.headerTitle = 'Manage Product';
          this.headerActions = [ this._searchAction ];
          this.subscribeToBackHeaderAction(this._reactToBackHeaderAction);
          this.subscribeToHeaderActions(this._reactToHeaderAction);
    }

    ngOnInit() {
        //Show back action in header section
        this._appStateService.changeBackActionValue(true);

        this._route.params.forEach((params: Params) => {
            let id = +params['id'];
            this._getProductById(id);
        });
    }

    onFilterChanged(filter: string) {

         if (filter) {
            this.locations = this.product.locations.filter(l => l.name.toLowerCase().indexOf(filter.toLowerCase()) >= 0);
         } else {
              this.locations = this.product.locations;
         }

         this.updateProductInformation();
     }

     onActionClicked(action: MenuItem, location: InventoryLocation) {

         switch (action.icon) {
                case 'edit':
                    this.locations.forEach(l => l.editMode = l.id === location.id);
                    break;
                case 'card-alert':
                    this._showReport(location);
                    break;
                case 'swap':
                    if (this._totalLocations > 1) {
                        this._transferProducts(location);
                    } else {
                        location.transferNotAllowed = true;
                    }

                    break;
         }
     }

     updateProductInformation() {
         let current = 0;
         let maximum = 0;

         this.locations.map(l => {
                current += +l.current;
                maximum += +l.maximum;
         });

         this.product.current = current;
         this.product.missQuantity = current - maximum;
     }

    coverClosed() {
        this.showReportDetails = false;
        this.headerTitle = 'Manage Product';
    }

    private _showReport(location: InventoryLocation) {
        this.locationSelectedToReport = location;
        this.showReportDetails = true;
    }

    private _transferProducts(location: InventoryLocation) {
        this._router.navigate(['/inventory/trasfer-product', this.product.id, location.id, 0]);
    }

    private _reactToHeaderAction(action: HeaderAction) {
         if (action.id === this._searchAction.id) {
            this.inputFilterSheetComponent.toggle();
         }
    }

    private _reactToBackHeaderAction() {
         this._router.navigate(['/inventory']);
    }

    private _getProductById(productId: number) {
        this._inventoryDetailService.getProductById(productId)
            .subscribe(
                (res: Product) => {
                    this.appPage.deactivatePreloader();
                    this.product = res;
                    this.locations = res.locations;
                    this._totalLocations = res.locations.length;
                },
                 error =>  console.log(error)
             );
     }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/inventory-detail/inventory-detail.component.ts